import { z } from 'zod';

const countByUserSchema = z.object({
  userId: z.coerce.number(),
  count: z.number(),
});

export const countsBySubmitterSchema = z.object({
  amCounts: z.array(countByUserSchema),
  zmCounts: z.array(countByUserSchema),
});

export type CountByUser = z.infer<typeof countByUserSchema>;
export type CountsBySubmitter = z.infer<typeof countsBySubmitterSchema>;
